import React, { useState } from "react"

import { useLocation } from "@reach/router"

import { SecondaryLinks, SecondaryMenu, ThirdMenu } from "../components/menu"
import Socials from "../components/socials"
import Link from "./link"
import Menu from "./menu"
import Spacer from "./spacer"

const Header = ({ className, project, buttonHide, register, isAlt = false, fixedLink }) => {
  const { pathname } = useLocation()
  const [isHolidaysPage, setIsHolidaysPage] = useState(false)

  const toggleMenu = () => {
    document.body.classList.toggle("menu-open")
    document.body.classList.remove("submenu-open")
  }

  const closeMenu = () => {
    document.body.classList.remove("menu-open")
    document.body.classList.remove("submenu-open")
    document.body.classList.remove("third-open")
  }

  const hideSubmenu = () => {
    document.body.classList.remove("submenu-open")
    document.body.classList.remove("third-open")
  }

  const scrollDown = () => {
    const height = document.getElementById("contact")?.offsetTop - 40
    window.scrollTo({ top: height, left: 0, behavior: "smooth" })
  }

  const isInternal = fixedLink?.split("")[0] === "/"
  const As = isInternal ? Link : "a"

  const props = isInternal ? { to: fixedLink } : { href: fixedLink, target: "_blank", rel: "noreferrer" }

  return (
    <>
      <header className={`masthead flex ${isHolidaysPage ? "alt" : ""} m-hide`}>
        <div className={`menu--navigation flex flex-wrap`}>
          <div className='mta w-100 mba ml60 p15 inner'>
            <Link to='/'>
              <div className='logo--footer pos-rel z-2' />
            </Link>
          </div>
          <div className='inner p15 flex flex-col mba mta mla mra w-100 ml60'>
            {isHolidaysPage ? <SecondaryLinks /> : <Menu />}

            {isHolidaysPage && (
              <>
                <Spacer />
                <Link to='/' activeClassName='active' className='h3 mta link menu-link'>
                  Explore the Precinct
                </Link>
                <div className='mta'>
                  <div className='address mt20 small w-100'>
                    4 Miles Street, Kirra, QLD 4225 <br />
                    <br />
                    Phone{" "}
                    <a className='ul-link link light' href='tel:(07) 5690 5000'>
                      (07) 5690 5000
                    </a>
                  </div>
                </div>
              </>
            )}
          </div>
          <div className='mta w-100 mba ml60 p15 inner'>
            <Socials />
          </div>
        </div>
        <div className={`menu--bar ${isAlt ? "alt" : ""}`}>
          <div className='p15 flex flex-wrap h-100a'>
            <div className='mobile--menu mba mt0' role='presentation' onClick={toggleMenu} />
            <Link className='mta' to='/'>
              <div className='logo--main' />
            </Link>
          </div>
        </div>
        {isHolidaysPage ? null : (
          <>
            <SecondaryMenu />
            <ThirdMenu />
          </>
        )}
      </header>

      <header className={`mobile--header ${isHolidaysPage ? "holidays" : ""} masthead m-show ${isAlt ? "alt" : ""}`}>
        <div className='menu--navigation flex'>
          <div className='inner ma w-100 ml60 m-ml20'>
            {isHolidaysPage ? <SecondaryLinks /> : <Menu />}

            {isHolidaysPage && (
              <>
                <Spacer />
                <Link to='/' activeClassName='active' className='h3 mta link menu-link'>
                  Explore the Precinct
                </Link>
                <div className='mta'>
                  <div className='address mt20 small w-100'>
                    4 Miles Street, Kirra, QLD 4225 <br />
                    <br />
                    Phone{" "}
                    <a className='ul-link link light' href='tel:(07) 5690 5000'>
                      (07) 5690 5000
                    </a>
                  </div>
                </div>
              </>
            )}
          </div>
        </div>
        <div className='menu--bar z-2'>
          <div className='flex flex-wrap h-100a m-align-center m-pl20 m-pr20'>
            <div className={"mobile--menu mba mt0 m-m0 " + (buttonHide || isHolidaysPage ? "m-mla" : "")} role='presentation' onClick={toggleMenu} />
            <Link to='/'>
              <div className='logo--main pos-rel z-2' />
            </Link>
            {!isHolidaysPage ? (
              <>
                {register ? (
                  <button className='enquiry-button button inverse link mla mr20 pos-rel z-2' onClick={scrollDown}>
                    Register Interest
                  </button>
                ) : (
                  <As {...props} className={"enquiry-button link mla mr20 pos-rel z-2 " + (buttonHide ? "hide" : "")} to='/'>
                    <button className='button brown inverse'>Book Now</button>
                  </As>
                )}
              </>
            ) : (
              <div />
            )}
          </div>
        </div>
      </header>
      <div className='menu--bg' role='presentation' onMouseOver={hideSubmenu} onClick={closeMenu} />
    </>
  )
}

export default Header

export const HeaderAlt = ({ className, project, buttonHide, register, isAlt = false, fixedLink }) => {
  const toggleMenu = () => {
    document.body.classList.toggle("alt-menu-open")
    document.body.classList.remove("menu-open")
    document.body.classList.remove("submenu-open")
  }

  const closeMenu = () => {
    document.body.classList.remove("alt-menu-open")
    document.body.classList.remove("menu-open")
    document.body.classList.remove("submenu-open")
  }

  const hideSubmenu = () => {
    document.body.classList.remove("submenu-open")
  }

  const scrollDown = () => {
    const height = document.getElementById("contact")?.offsetTop - 40
    window.scrollTo({ top: height, left: 0, behavior: "smooth" })
  }

  const isInternal = fixedLink?.split("")[0] === "/"
  const As = isInternal ? Link : "a"

  const props = isInternal ? { to: fixedLink } : { href: fixedLink, target: "_blank", rel: "noreferrer" }

  return (
    <>
      <header className={`masthead flex alt m-hide`}>
        <div className={`menu--navigation alt flex flex-wrap`}>
          <div className='mta w-100 mba ml60 p15 inner'>
            <Link to='/'>
              <div className='logo--footer pos-rel z-2' />
            </Link>
          </div>
          <div className='inner p15 mba mta mla mra w-100 ml60'>
            <SecondaryLinks />

            <Spacer />
            <Link to='/' activeClassName='active' className='h3 mta link menu-link'>
              Explore the Precinct
            </Link>
          </div>
          <div className='mta w-100 mba ml60 p15 inner'>
            <div className='address mt20 small mb20 w-100'>
              4 Miles Street, Kirra, QLD 4225 <br />
              <br />
              Phone{" "}
              <a className='ul-link link light' href='tel:(07) 5690 5000'>
                (07) 5690 5000
              </a>
            </div>
            <Socials />
          </div>
        </div>
        <div className={`menu--bar ${isAlt ? "alt" : ""}`}>
          <div className='p15 flex flex-wrap h-100a'>
            <div className='mobile--menu mba mt0' role='presentation' onClick={toggleMenu} />
            <Link className='mta' to='/'>
              <div className='logo--main' />
            </Link>
          </div>
        </div>
      </header>

      <header className={`mobile--header holidays masthead m-show ${isAlt ? "alt" : ""}`}>
        <div className='menu--navigation alt flex'>
          <div className='inner ma w-100 ml60 m-ml20'>
            <SecondaryLinks />

            <Spacer />
            <Link to='/' activeClassName='active' className='h3 mta link menu-link'>
              Explore the Precinct
            </Link>
          </div>
        </div>
        <div className='menu--bar z-2'>
          <div className='flex space-between flex-wrap h-100a m-align-center m-pl20 m-pr20'>
            <div className={"mobile--menu mba mt0 m-m0 " + ""} role='presentation' onClick={toggleMenu} />
            <Link to='/'>
              <div className='logo--main pos-rel z-2 mra' />
            </Link>
            <As {...props} className={"enquiry-button link mla mr20 pos-rel z-2 " + (buttonHide ? "hide" : "")} to='/'>
              <button className='button'>Book Now</button>
            </As>
          </div>
        </div>
      </header>
      <div className='menu--bg-alt' role='presentation' onMouseOver={hideSubmenu} onClick={closeMenu} />
    </>
  )
}
